/**
 * Short, memorable link to a field user's setup card: `/card/<employee-id>`.
 *
 * Deliberately keyed on the employee ID people already say out loud
 * ("A-001") rather than a UUID, so the URL can be read down a phone line.
 */
export function cardPath(employeeId: string): string {
  return `/card/${encodeURIComponent(employeeId)}`;
}

/** Absolute form, for copy-to-clipboard and sharing. */
export function cardUrl(employeeId: string): string {
  return `${window.location.origin}${cardPath(employeeId)}`;
}
